export { default } from './QuestionConfirm';